module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Merge Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs5"
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                Base Job\n              ")]), _vm._v(" "), _c('v-card-text', [(_vm.retreivedJobs[0]) ? [_c('p', [_vm._v("Products: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[0].products ? _vm.retreivedJobs[0].products.length : 0))])]), _vm._v(" "), _c('p', [_vm._v("Completed Photos & Notes: "), _c('v-icon', [_vm._v(_vm._s(_vm.completedJobs[0] ? 'check' : 'close'))])], 1), _vm._v(" "), _c('p', [_vm._v("Completed Documents: "), (_vm.retreivedJobs[0].completedDocs) ? _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[0].completedDocs.length) + " docs")]) : _c('strong', [_vm._v("0 docs")])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('strong', [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.retreivedJobs[0].Status)))])]), _vm._v(" "), _c('p', [_vm._v("Completed date: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[0].CompletedDate))])]), _vm._v(" "), _c('p', [_vm._v("Job No: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[0].JobNo))])]), _vm._v(" "), _c('p', [_vm._v("Project ID: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[0].Project))])])] : _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs2 text-xs-center"
  }, [_c('v-btn', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.swapBaseJob()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-swap-horizontal")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs5"
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                Job to merge from\n              ")]), _vm._v(" "), _c('v-card-text', [(_vm.retreivedJobs[1]) ? [_c('p', [_vm._v("Products: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[1].products ? _vm.retreivedJobs[1].products.length : 0))])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Completed Images & Notes: "), _c('v-icon', [_vm._v(_vm._s(_vm.completedJobs[1] ? 'check' : 'close') + " docs")])], 1)]
      },
      proxy: true
    }], null, false, 1134128123),
    model: {
      value: (_vm.mergeCompletedJob),
      callback: function($$v) {
        _vm.mergeCompletedJob = $$v
      },
      expression: "mergeCompletedJob"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Completed Documents: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[1].completedDocs ? _vm.retreivedJobs[1].completedDocs.length : 0) + " docs")])])]
      },
      proxy: true
    }], null, false, 842762644),
    model: {
      value: (_vm.mergedJobMap.completedDocs),
      callback: function($$v) {
        _vm.$set(_vm.mergedJobMap, "completedDocs", $$v)
      },
      expression: "mergedJobMap.completedDocs"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Status: "), _c('strong', [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.retreivedJobs[1].Status)))])])]
      },
      proxy: true
    }], null, false, 1934719000),
    model: {
      value: (_vm.mergedJobMap.Status),
      callback: function($$v) {
        _vm.$set(_vm.mergedJobMap, "Status", $$v)
      },
      expression: "mergedJobMap.Status"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Completed Date: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[1].CompletedDate))])])]
      },
      proxy: true
    }], null, false, 1758952309),
    model: {
      value: (_vm.mergedJobMap.CompletedDate),
      callback: function($$v) {
        _vm.$set(_vm.mergedJobMap, "CompletedDate", $$v)
      },
      expression: "mergedJobMap.CompletedDate"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0",
      "label": 'JobNo ' + _vm.retreivedJobs[1].JobNo
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Job No: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[1].JobNo))])])]
      },
      proxy: true
    }], null, false, 3958954613),
    model: {
      value: (_vm.mergedJobMap.JobNo),
      callback: function($$v) {
        _vm.$set(_vm.mergedJobMap, "JobNo", $$v)
      },
      expression: "mergedJobMap.JobNo"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "height": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("\n                        Project ID: "), _c('strong', [_vm._v(_vm._s(_vm.retreivedJobs[1].Project))])])]
      },
      proxy: true
    }], null, false, 3081358488),
    model: {
      value: (_vm.mergedJobMap.Project),
      callback: function($$v) {
        _vm.$set(_vm.mergedJobMap, "Project", $$v)
      },
      expression: "mergedJobMap.Project"
    }
  })] : _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-source-fork")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12"
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                Merged Job\n              ")]), _vm._v(" "), _c('v-card-text', [(_vm.mergedJob) ? [_c('p', [_vm._v("Products: "), _c('strong', [_vm._v(_vm._s(_vm.mergedJob.products ? _vm.mergedJob.products.length : 0))])]), _vm._v(" "), _c('p', [_vm._v("Completed Photos & Notes: "), _c('v-icon', [_vm._v(_vm._s(_vm.completedJobs[_vm.mergeCompletedJob ? 1 : 0] ? 'check' : 'close'))])], 1), _vm._v(" "), _c('p', [_vm._v("Completed Documents: "), (_vm.mergedJob.completedDocs) ? _c('strong', [_vm._v(_vm._s(_vm.mergedJob.completedDocs.length) + " docs")]) : _c('strong', [_vm._v("0 docs")])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('strong', [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.mergedJob.Status)))])]), _vm._v(" "), _c('p', [_vm._v("Completed date: "), _c('strong', [_vm._v(_vm._s(_vm.mergedJob.CompletedDate))])]), _vm._v(" "), _c('p', [_vm._v("Job No: "), _c('strong', [_vm._v(_vm._s(_vm.mergedJob.JobNo))])]), _vm._v(" "), _c('p', [_vm._v("Project ID: "), _c('strong', [_vm._v(_vm._s(_vm.mergedJob.Project))])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Please confirm you have checked the merged job is correct. Clicking 'Merge' will overwrite both jobs with the details shown above."
    },
    model: {
      value: (_vm.confirmMerge),
      callback: function($$v) {
        _vm.confirmMerge = $$v
      },
      expression: "confirmMerge"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.merging,
      "color": "primary",
      "disabled": !_vm.confirmMerge
    },
    on: {
      "click": _vm.mergeJobs
    }
  }, [_vm._v("Merge")])] : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4589682e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/MergeJobsDialog.vue
// module id = 747
// module chunks = 1